import {
  useCallback,
  useMemo
} from 'react';

import _ from 'lodash';

import {
  PartnerActionsWidgetDocument,
  useCloseOrderMutation,
  usePartnerActionsWidgetQuery
} from 'generated/graphql';



export interface IData {
  canCloseOrder: boolean;
  canInitiateReturnAuthorization: boolean;
  hasReturnAuthorization: boolean;
}

export function useQuery(orderId: string) {
  const tuple = usePartnerActionsWidgetQuery({
    variables: {
      orderId
    }
  });

  return useMemo(
    () => {
      const order = tuple.data?.order;
      const data: IData = {
        canCloseOrder: tuple.data?.canCloseOrder ?? false,
        canInitiateReturnAuthorization: tuple.data?.canInitiateReturnAuthorization ?? false,
        hasReturnAuthorization: !_.isEmpty(order?.returnAuthorizations.nodes ?? [])
      };

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}



export function useCloseOrder(orderId: string) {
  const [fnMutate, tuple] = useCloseOrderMutation({
    refetchQueries: [
      {
        query: PartnerActionsWidgetDocument,
        variables: { orderId }
      }
    ]
  });

  const fnWrappedMutate = useCallback(async () => {
    fnMutate({
      variables: {
        orderId
      }
    });
  }, [fnMutate, orderId]);

  return useMemo(() => [
    fnWrappedMutate,
    {
      ...tuple,
      data: null
    }
  ] as const, [
    fnWrappedMutate,
    tuple
  ]);
}
